import { render } from "./FirstPaymentFinalConfirmation.vue?vue&type=template&id=b38e9e70"
import script from "./FirstPaymentFinalConfirmation.vue?vue&type=script&lang=js"
export * from "./FirstPaymentFinalConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__